import { getTestId } from '@airtel/air-design-system';
export var defaultProps = Object.assign({
  planDetailTitle: 'PLAN DETAILS',
  planInfoData: {
    planName: 'Infinity Family 399 plan',
    amount: '₹399',
    subText: 'GST will be calculated at checkout',
    alignment: 'left'
  },
  infoTagText: 'offer',
  ctaText: 'Buy Now',
  multiInfoTags: [{
    text: '2 SIMs'
  }, {
    text: 'Instant Upgrade'
  }],
  benefitsColCountDesktop: 2,
  benefitData: [{
    imageUrl: 'https://assets.airtel.in/static-assets/home-recast/images/recommendations-slide-1.png',
    data: {
      multiText: [{
        text: '40 GB ',
        type: 'body-para-sm-bold'
      }, {
        text: 'data',
        type: 'body-para-sm'
      }]
    }
  }, {
    imageUrl: 'https://assets.airtel.in/static-assets/home-recast/images/recommendations-slide-1.png',
    data: {
      multiText: [{
        text: '40 GB ',
        type: 'body-para-sm-bold'
      }, {
        text: 'data',
        type: 'body-para-sm'
      }]
    }
  }, {
    imageUrl: 'https://assets.airtel.in/static-assets/home-recast/images/recommendations-slide-1.png',
    data: {
      multiText: [{
        text: '40 GB ',
        type: 'body-para-sm-bold'
      }, {
        text: 'data',
        type: 'body-para-sm'
      }]
    }
  }, {
    imageUrl: 'https://assets.airtel.in/static-assets/home-recast/images/recommendations-slide-1.png',
    data: {
      multiText: [{
        text: '40 GB ',
        type: 'body-para-sm-bold'
      }, {
        text: 'data',
        type: 'body-para-sm'
      }]
    }
  }, {
    icon: 'ChatSupportButtonIcon',
    data: {
      multiText: [{
        text: '100 SMS ',
        type: 'body-para-sm-bold'
      }, {
        text: 'per day',
        type: 'body-para-sm'
      }]
    }
  }, {
    icon: 'CallIcon',
    data: {
      multiText: [{
        text: 'unlimited calls ',
        type: 'body-para-sm-bold'
      }, {
        text: '(local & STD roaming)',
        type: 'body-para-sm'
      }]
    }
  }, {
    icon: 'SimIcon',
    data: {
      multiText: [{
        text: 'Wynk Music ',
        type: 'body-para-sm-bold'
      }, {
        text: '· 1 year',
        type: 'body-para-sm'
      }]
    }
  }, {
    icon: 'SimIcon',
    data: {
      multiText: [{
        text: 'Wynk Music ',
        type: 'body-para-sm-bold'
      }, {
        text: '· 1 year',
        type: 'body-para-sm'
      }]
    }
  }, {
    icon: 'SimIcon',
    data: {
      multiText: [{
        text: 'Wynk Music ',
        type: 'body-para-sm-bold'
      }, {
        text: '· 1 year',
        type: 'body-para-sm'
      }]
    }
  }, {
    icon: 'SimIcon',
    data: {
      multiText: [{
        text: 'Wynk Music ',
        type: 'body-para-sm-bold'
      }, {
        text: '· 1 year',
        type: 'body-para-sm'
      }]
    }
  }, {
    icon: 'SimIcon',
    data: {
      multiText: [{
        text: 'Wynk Music ',
        type: 'body-para-sm-bold'
      }, {
        text: '· 1 year',
        type: 'body-para-sm'
      }]
    }
  }, {
    icon: 'SimIcon',
    data: {
      multiText: [{
        text: 'Wynk Music ',
        type: 'body-para-sm-bold'
      }, {
        text: '· 1 year',
        type: 'body-para-sm'
      }]
    }
  }, {
    icon: 'SimIcon',
    data: {
      multiText: [{
        text: 'Wynk Music ',
        type: 'body-para-sm-bold'
      }, {
        text: '· 1 year',
        type: 'body-para-sm'
      }]
    }
  }, {
    icon: 'SimIcon',
    data: {
      multiText: [{
        text: 'Wynk Music ',
        type: 'body-para-sm-bold'
      }, {
        text: '· 1 year',
        type: 'body-para-sm'
      }]
    }
  }, {
    icon: 'SimIcon',
    data: {
      multiText: [{
        text: '1 ',
        type: 'body-para-sm-bold'
      }, {
        text: 'SIM',
        type: 'body-para-sm'
      }]
    }
  }, {
    icon: 'DataTopUpIcon',
    data: {
      multiText: [{
        text: '40 GB ',
        type: 'body-para-sm-bold'
      }, {
        text: ' data',
        type: 'body-para-sm'
      }]
    }
  }, {
    icon: 'ChatSupportButtonIcon',
    data: {
      multiText: [{
        text: '100 SMS ',
        type: 'body-para-sm-bold'
      }, {
        text: 'per day',
        type: 'body-para-sm'
      }]
    }
  }, {
    icon: 'CallIcon',
    data: {
      multiText: [{
        text: 'unlimited calls ',
        type: 'body-para-sm-bold'
      }, {
        text: '(local & STD roaming)',
        type: 'body-para-sm'
      }]
    }
  }, {
    icon: 'SimIcon',
    data: {
      multiText: [{
        text: 'Wynk Music',
        type: 'body-para-sm-bold'
      }, {
        text: '· 1 year',
        type: 'body-para-sm'
      }]
    }
  }, {
    icon: 'SimIcon',
    data: {
      multiText: [{
        text: 'Wynk Music 11',
        type: 'body-para-sm'
      }, {
        text: '· 1 year',
        type: 'body-para-sm'
      }]
    }
  }],
  viewAllCtaProps: {
    collapsedText: 'view all',
    onViewAllCtaPress: {}
  }
}, getTestId('PlanDetailsWidgetContainer'));